import { PlusOutlineIcon } from '@carboncopyco/icons';
import { ColorHex, TextBase } from '@carboncopyco/ui';
import classnames from 'classnames';
import { useWorkspaceManageTag } from './WorkspaceManageTagContext';

const dummyInputBaseClassnames =
  'w-full h-9 flex justify-between items-center gap-2 mt-2 px-2 rounded-lg';

export const WorkspaceManageTagCreate = () => {
  const { searchKey, searchKeyExists, createTag } = useWorkspaceManageTag();
  const createTagText = 'Create tag';
  const createTagLabel = `${createTagText} "${searchKey}"`;
  const disabled = searchKeyExists || !searchKey;
  return (
    <div className="w-full">
      <div className="flex justify-end items-center w-full mt-1">
        <div
          className={classnames(
            dummyInputBaseClassnames,
            disabled
              ? 'bg-ds-natural-100 cursor-default'
              : 'bg-ds-primary-50  cursor-pointer truncate'
          )}
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            !disabled && createTag();
          }}
        >
          <div className="max-w-130 truncate">
            <TextBase
              color={disabled ? 'text-ds-natural-300' : 'text-ds-primary-300'}
              label={disabled ? createTagText : createTagLabel}
            />
          </div>
          {disabled ? (
            <PlusOutlineIcon color={ColorHex.natural200} />
          ) : (
            <PlusOutlineIcon color={ColorHex.primary300} />
          )}
        </div>
      </div>
    </div>
  );
};
